var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"app8-logo-container"},[_c('a',{attrs:{"href":"https://www.app8solutions.com/","target":"_blank","rel":"noopener noreferrer"}},[(_vm.$i18n.locale && _vm.$i18n.locale.toLowerCase().includes('fr'))?_c('powered-by-app8-fr'):_c('powered-by-app8-en')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }